import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export default function SideModal({ open, onClose, title, children }) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      hideBackdrop
      disableEscapeKeyDown
      fullScreen
      sx={{
        "& .MuiDialog-paper": {
          margin: 0,
          right: 0,
          position: "fixed",
          backgroundColor: theme.palette.background.paper,
          borderLeft: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.palette.mode === 'dark' 
            ? '0px 0px 20px rgba(0,0,0,0.4)'
            : '0px 0px 20px rgba(0,0,0,0.1)',
        },
      }}
    >
      {/* Modal Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1.5,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.mode === 'dark' 
            ? theme.palette.grey[900]
            : theme.palette.grey[50],
        }}
      >
        <Typography 
          variant="h6" 
          sx={{ 
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        <IconButton 
          onClick={onClose} 
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': {
              backgroundColor: theme.palette.mode === 'dark' 
                ? theme.palette.grey[800]
                : theme.palette.grey[100],
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Modal Content */}
      <DialogContent 
        sx={{ 
          height: "calc(100vh - 64px)", 
          overflowY: "auto",
          backgroundColor: theme.palette.background.paper,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: theme.palette.mode === 'dark' 
              ? theme.palette.grey[900]
              : theme.palette.grey[100],
          },
          '&::-webkit-scrollbar-thumb': {
            background: theme.palette.mode === 'dark' 
              ? theme.palette.grey[700]
              : theme.palette.grey[300],
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: theme.palette.mode === 'dark' 
              ? theme.palette.grey[600]
              : theme.palette.grey[400],
          },
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}
